import React, { useState } from "react";
import Navbar from "../layouts/Navbar";
import TimeLine from '../layouts/Timeline';
import About from '../layouts/About';
import NotificationBar from "../layouts/NotificationBar";
import Banner from "../layouts/Banner";
import HeroSection from "../layouts/HeroSection";
import Guidelines from "../layouts/Guidelines";
import AwardsSection from "../layouts/AwardsSection";
import Team from '../layouts/Team';
import Footer from '../layouts/footer';
import Workshop from "../layouts/Workshop";
import PhotoGallery from "../layouts/PhotoGallery";


const HomePage = () => {
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);

  return (
    <>
      {/* <NotificationBar setIsNotificationVisible={setIsNotificationVisible} /> */}
      <Navbar isNotificationVisible={isNotificationVisible} />
      {/*<Banner />*/}
      <HeroSection />
      <About />
      <PhotoGallery />
      <TimeLine />
      <Guidelines />
      <Workshop />
      <AwardsSection />
      <Team />
      <Footer />
    </>

  );
};

export default HomePage;
